var map = {
	"./AD.svg": 8647,
	"./AE.svg": 7812,
	"./AF.svg": 5472,
	"./AG.svg": 21,
	"./AI.svg": 4826,
	"./AL.svg": 5078,
	"./AM.svg": 8119,
	"./AO.svg": 9513,
	"./AQ.svg": 6980,
	"./AR.svg": 6664,
	"./AS.svg": 75,
	"./AT.svg": 5512,
	"./AU.svg": 5973,
	"./AW.svg": 1860,
	"./AX.svg": 4225,
	"./AZ.svg": 1697,
	"./BA.svg": 9030,
	"./BB.svg": 5889,
	"./BD.svg": 8399,
	"./BE.svg": 4667,
	"./BF.svg": 6058,
	"./BG.svg": 9028,
	"./BH.svg": 9164,
	"./BI.svg": 401,
	"./BJ.svg": 289,
	"./BL.svg": 2276,
	"./BM.svg": 1551,
	"./BN.svg": 9729,
	"./BO.svg": 1036,
	"./BQ.svg": 273,
	"./BR.svg": 127,
	"./BS.svg": 8411,
	"./BT.svg": 7600,
	"./BV.svg": 8957,
	"./BW.svg": 3298,
	"./BY.svg": 2786,
	"./BZ.svg": 6623,
	"./CA.svg": 4988,
	"./CC.svg": 3180,
	"./CD.svg": 6071,
	"./CF.svg": 1605,
	"./CG.svg": 1276,
	"./CH.svg": 4782,
	"./CI.svg": 1817,
	"./CK.svg": 1245,
	"./CL.svg": 5335,
	"./CM.svg": 3889,
	"./CN.svg": 6651,
	"./CO.svg": 2754,
	"./CR.svg": 4136,
	"./CU.svg": 6385,
	"./CV.svg": 2951,
	"./CW.svg": 3037,
	"./CX.svg": 2096,
	"./CY.svg": 5829,
	"./CZ.svg": 2274,
	"./DE.svg": 1449,
	"./DJ.svg": 4775,
	"./DK.svg": 4962,
	"./DM.svg": 8847,
	"./DO.svg": 2992,
	"./DZ.svg": 6505,
	"./EC.svg": 5184,
	"./EE.svg": 6360,
	"./EG.svg": 3458,
	"./EH.svg": 691,
	"./ER.svg": 7045,
	"./ES.svg": 338,
	"./ET.svg": 1428,
	"./EU.svg": 6397,
	"./FI.svg": 7930,
	"./FJ.svg": 3402,
	"./FK.svg": 2014,
	"./FM.svg": 5496,
	"./FO.svg": 3760,
	"./FR.svg": 4983,
	"./GA.svg": 9344,
	"./GB.svg": 4568,
	"./GD.svg": 683,
	"./GE.svg": 914,
	"./GF.svg": 5304,
	"./GG.svg": 9969,
	"./GH.svg": 5027,
	"./GI.svg": 1838,
	"./GL.svg": 1390,
	"./GM.svg": 7422,
	"./GN.svg": 265,
	"./GP.svg": 5228,
	"./GQ.svg": 7280,
	"./GR.svg": 2258,
	"./GS.svg": 9836,
	"./GT.svg": 4137,
	"./GU.svg": 467,
	"./GW.svg": 739,
	"./GY.svg": 9848,
	"./HK.svg": 5577,
	"./HM.svg": 2408,
	"./HN.svg": 3041,
	"./HR.svg": 9325,
	"./HT.svg": 1403,
	"./HU.svg": 9520,
	"./ID.svg": 5667,
	"./IE.svg": 409,
	"./IL.svg": 3157,
	"./IM.svg": 2287,
	"./IN.svg": 6680,
	"./IO.svg": 6604,
	"./IQ.svg": 3373,
	"./IR.svg": 2482,
	"./IS.svg": 1949,
	"./IT.svg": 563,
	"./JE.svg": 3755,
	"./JM.svg": 6249,
	"./JO.svg": 3921,
	"./JP.svg": 907,
	"./KE.svg": 1913,
	"./KG.svg": 7695,
	"./KH.svg": 1421,
	"./KI.svg": 4547,
	"./KM.svg": 1362,
	"./KN.svg": 650,
	"./KP.svg": 9772,
	"./KR.svg": 870,
	"./KW.svg": 8455,
	"./KY.svg": 6697,
	"./KZ.svg": 1633,
	"./LA.svg": 1072,
	"./LB.svg": 8659,
	"./LC.svg": 4807,
	"./LI.svg": 4114,
	"./LK.svg": 4390,
	"./LR.svg": 1894,
	"./LS.svg": 4942,
	"./LT.svg": 4214,
	"./LU.svg": 6114,
	"./LV.svg": 1151,
	"./LY.svg": 1178,
	"./MA.svg": 9748,
	"./MC.svg": 1924,
	"./MD.svg": 2167,
	"./ME.svg": 3251,
	"./MF.svg": 9550,
	"./MG.svg": 8008,
	"./MH.svg": 5352,
	"./MK.svg": 2923,
	"./ML.svg": 2716,
	"./MM.svg": 7411,
	"./MN.svg": 6838,
	"./MO.svg": 6324,
	"./MP.svg": 9480,
	"./MQ.svg": 9730,
	"./MR.svg": 2867,
	"./MS.svg": 4995,
	"./MT.svg": 5867,
	"./MU.svg": 2546,
	"./MV.svg": 2906,
	"./MW.svg": 5126,
	"./MX.svg": 9085,
	"./MY.svg": 4906,
	"./MZ.svg": 3228,
	"./NA.svg": 1127,
	"./NC.svg": 8564,
	"./NE.svg": 876,
	"./NF.svg": 4325,
	"./NG.svg": 2595,
	"./NI.svg": 1049,
	"./NL.svg": 1854,
	"./NO.svg": 5345,
	"./NP.svg": 5220,
	"./NR.svg": 9347,
	"./NU.svg": 4397,
	"./NZ.svg": 7176,
	"./OM.svg": 4852,
	"./PA.svg": 5135,
	"./PE.svg": 8033,
	"./PF.svg": 2594,
	"./PG.svg": 3012,
	"./PH.svg": 3767,
	"./PK.svg": 2275,
	"./PL.svg": 2251,
	"./PM.svg": 3384,
	"./PN.svg": 6358,
	"./PR.svg": 1087,
	"./PS.svg": 317,
	"./PT.svg": 3145,
	"./PW.svg": 9894,
	"./PY.svg": 8134,
	"./QA.svg": 2077,
	"./RE.svg": 4243,
	"./RO.svg": 9364,
	"./RS.svg": 6786,
	"./RU.svg": 7245,
	"./RW.svg": 2603,
	"./SA.svg": 2164,
	"./SB.svg": 1154,
	"./SC.svg": 8555,
	"./SD.svg": 4431,
	"./SE.svg": 5366,
	"./SG.svg": 8791,
	"./SH.svg": 9826,
	"./SI.svg": 9896,
	"./SJ.svg": 9554,
	"./SK.svg": 3650,
	"./SL.svg": 8966,
	"./SM.svg": 5641,
	"./SN.svg": 7535,
	"./SO.svg": 5400,
	"./SR.svg": 5007,
	"./SS.svg": 8451,
	"./ST.svg": 2647,
	"./SV.svg": 4388,
	"./SX.svg": 5899,
	"./SY.svg": 2357,
	"./SZ.svg": 9789,
	"./TC.svg": 5077,
	"./TD.svg": 8514,
	"./TF.svg": 6307,
	"./TG.svg": 5444,
	"./TH.svg": 4280,
	"./TJ.svg": 6572,
	"./TK.svg": 6470,
	"./TL.svg": 4951,
	"./TM.svg": 1659,
	"./TN.svg": 2018,
	"./TO.svg": 5791,
	"./TR.svg": 468,
	"./TT.svg": 2597,
	"./TV.svg": 8907,
	"./TW.svg": 2037,
	"./TZ.svg": 1918,
	"./UA.svg": 9189,
	"./UG.svg": 6688,
	"./UM.svg": 8124,
	"./US.svg": 8116,
	"./UY.svg": 6758,
	"./UZ.svg": 4484,
	"./VA.svg": 3872,
	"./VC.svg": 6312,
	"./VE.svg": 5535,
	"./VG.svg": 4781,
	"./VI.svg": 8979,
	"./VN.svg": 4510,
	"./VU.svg": 2564,
	"./WF.svg": 5180,
	"./WS.svg": 4559,
	"./YE.svg": 5625,
	"./YT.svg": 7878,
	"./ZA.svg": 4503,
	"./ZM.svg": 9593,
	"./ZW.svg": 8123,
	"./pirate.svg": 9571,
	"./rainbow.svg": 2922,
	"./trans.svg": 7598
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4027;